<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'QRVEY Applications'"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource?.loading$"
  >
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetSearchInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Application Name </mat-header-cell>
          <mat-cell *matCellDef="let app">
            <span>{{ app.name }}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchName">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>Application Name</mat-label>
              <input matInput [placeholder]="'Application Name'" [(ngModel)]="searchNameInput" />
              <button
                *ngIf="searchNameInput"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchNameInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Type </mat-header-cell>
          <mat-cell *matCellDef="let app">
            <span>{{ app.type }}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchType">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>Type</mat-label>
              <mat-select [(value)]="searchTypeSelect" [placeholder]="'Type'">
                <mat-option value="">All</mat-option>
                <mat-option value="KNOSTOS">Knostos</mat-option>
                <mat-option value="CUSTOM">Custom</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let app">
            <button
              matTooltip="Edit Application"
              (click)="editPageGroup(app)"
              class="btn btn-icon btn-light btn-hover-primary btn-sm margin-2"
            >
              <span class="svg-icon svg-icon-md svg-icon-primary">
                <span inlineSVG="./assets/media/svg/icons/General/edit_icon.svg"></span>
              </span>
            </button>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarColumns"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="pageSize || 25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
